export default __webpack_public_path__ + "03241738ff3d3b0c59c6ab00808081e5.png";